import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditParentForm } from '@/features/parent'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/parents/update/$parentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { parentId } = Route.useParams()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование родителя')}>
      <EditParentForm parentId={parentId} onClose={close} />
    </Offcanvas>
  )
}
